

































































import { Component, Vue } from "vue-property-decorator";
import QuickSnack from "@/components/QuickSnack.vue";
import { queryAllTopayMessages, getVendingOptions } from "@/domain/backend/vending";
import { logError } from "@/util";
import * as uiUtil from "@/uiUtil";
import { TopayMessageResponse, VendingConfigOptions } from "@/domain/api";

@Component({
  components: { QuickSnack }
})
export default class TopayMessages extends Vue {
  isLoading = false;
  messages: TopayMessageResponse[] = [];
  vendingOptions: VendingConfigOptions | null = null;

  get lang() {
    return this.$store.state.lang.data;
  }

  get snack(): QuickSnack {
    return this.$refs.snack as QuickSnack;
  }

  async created() {
    this.vendingOptions = await getVendingOptions();
    await this.refresh();
  }

  async refresh() {
    try {
      this.isLoading = true;
      const result = await queryAllTopayMessages();
      this.messages = result.topayMessages;
    } catch (ex) {
      logError("Error loading topay messages", { ex });
      this.snack.show(this.lang.errorLoadingData + ": " + (ex as Error).message, "error");
    } finally {
      this.isLoading = false;
    }
  }

  topayMessageType(type: string): string {
    return this.vendingOptions?.topayOptions?.messageTypes[type] ?? type;
  }

  timestamp(timestamp: number): string {
    return new Date(timestamp).toLocaleString();
  }

  canGoToTerminal(msg: TopayMessageResponse): boolean {
    return !!msg.companyID && !!msg.branchID;
  }

  goToTerminal(msg: TopayMessageResponse) {
    if (!this.canGoToTerminal(msg)) return;
    uiUtil.routePush(this, {
      path: "/vendingConfig",
      query: {
        companyID: (msg.companyID as number).toString(),
        branchID: (msg.branchID as number).toString(),
        terminalID: msg.terminalID || "",
        tcod: msg.tcod
      }
    });
  }
}
